import styled from 'styled-components'
import { margin } from 'theme/default'

export const Divider = styled.hr`
  border: 0;
  width: 100%;
  min-height: 2px;
  border-top: 1px solid ${props => props.color || props.theme.colorLinesAndBorders};
  ${props => props.margin ? `margin: ${margin[props.margin]};` : ''}
  ${props => props.marginLeft ? `margin-left: ${margin[props.marginLeft]};` : ''}
  ${props => props.marginRight ? `margin-right: ${margin[props.marginRight]};` : ''}
  ${props => props.marginTop ? `margin-top: ${margin[props.marginTop]};` : ''}
  ${props => props.marginBottom ? `margin-bottom: ${margin[props.marginBottom]};` : ''}
`
Divider.defaultProps = {
  theme: {
    colorLinesAndBorders: 'rgba(214, 214, 214, 1)'
  }
}

export default Divider
